module.exports = __webpack_public_path__ + "static/media/291848.04eb5766.png";